import { useGetAuthenticatedUserQuery } from "@/src/graphql/generated/api/graphql";
import { type Permission } from "./Permission.type";

export const usePermissions = () => {
    const { data, loading } = useGetAuthenticatedUserQuery();

    const permissions =
        data?.getAuthenticatedUser?.role?.permissions.map((p) => p.key) || [];

    const hasPermission = (permission: Permission): boolean => {
        return permissions.includes(permission);
    };

    const hasAnyPermission = (permissionList: Permission[]): boolean => {
        return permissionList.some((permission) => hasPermission(permission));
    };

    const hasAllPermissions = (permissionList: Permission[]): boolean => {
        return permissionList.every((permission) => hasPermission(permission));
    };

    return {
        permissions,
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        loading,
        user: data?.getAuthenticatedUser,
    };
};
